import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate } from './components/AuthGate';
import { LoginPage } from './pages/LoginPage';
import { ProjectListPage } from './pages/ProjectListPage';
import { ProjectLayout } from './pages/ProjectLayout';
import { DagPage } from './pages/DagPage';
import { TaskListPage } from './pages/TaskListPage';
import { RunsPage } from './pages/RunsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ActivityPage } from './pages/ActivityPage';
import { SuggestionInboxPage } from './pages/SuggestionInboxPage';
import { WbsPage } from './pages/WbsPage';
import { MyTasksPage } from './pages/MyTasksPage';
import { AdminPage } from './pages/AdminPage';
import { DashboardPage } from './pages/DashboardPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AuthGate />}>
        <Route path="/" element={<ProjectListPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/projects/:projectId" element={<ProjectLayout />}>
          <Route index element={<Navigate to="dag" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="me" element={<MyTasksPage />} />
          <Route path="dag" element={<DagPage />} />
          <Route path="wbs" element={<WbsPage />} />
          <Route path="list" element={<TaskListPage />} />
          <Route path="runs" element={<RunsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="activity" element={<ActivityPage />} />
          <Route path="suggestions" element={<SuggestionInboxPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
